import { useTheme } from 'styled-components';

import { Button, Input, Typography } from '../../../designComponents';
import { ContainerStyled, NewsLetterStyled } from './style';

const NewsLetter = () => {
  const theme = useTheme();
  return (
    <NewsLetterStyled>
      <ContainerStyled>
        <div className="main-text">
          <Typography variant="title" className="get-update">
            Get update every week.
          </Typography>
          <Typography
            variant="heading"
            strong
            style={{ color: theme.colors.landingSecondaryText }}
            className="join"
          >
            Join Our Newsletter Today.
          </Typography>
        </div>
        <div className="subscribe">
          <div className="subscribe-input">
            <Input placeholder="Enter your email address" className="input" />
            <Button style={{ borderRadius: '5px' }} onClick={() => {}}>
              Subscribe
            </Button>
          </div>
          <Typography style={{ color: theme.colors.tabText }}>
            Stay up to date with our new features, latest templates and symbols
            and special offer! We announce a new feature or symbols every week
            so be sure to stay tuned.
          </Typography>
        </div>
      </ContainerStyled>
    </NewsLetterStyled>
  );
};

export default NewsLetter;
